const PackagingIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2692_11640)"
        fill-opacity="0.1"
      />
      <g clip-path="url(#clip0_2692_11640)">
        <path
          d="M9.62801 15.1981C9.87112 15.3197 10.0958 15.4191 10.3058 15.5407C10.3536 15.5665 10.3757 15.6733 10.3757 15.7396C10.3794 17.2277 10.3831 18.7194 10.3757 20.2075C10.3757 20.3696 10.4199 20.4543 10.571 20.5279C12.4126 21.4414 14.2506 22.3623 16.0923 23.2831C16.1439 23.3089 16.1991 23.331 16.2802 23.3641C16.2802 21.0694 16.2802 18.8041 16.2802 16.4983C16.5454 16.6567 16.7811 16.793 17.0132 16.933C17.3483 17.1356 17.6872 17.3308 18.0187 17.5407C18.144 17.6218 18.2471 17.6291 18.3871 17.5592C19.7167 16.8851 21.0538 16.2147 22.3872 15.548C22.5566 15.4633 22.7261 15.386 22.9139 15.2976C22.9176 15.3676 22.925 15.4228 22.925 15.4744C22.925 17.2203 22.925 18.9662 22.9286 20.7121C22.9286 20.8558 22.8844 20.9258 22.7555 20.9884C20.6486 22.0381 18.5418 23.0916 16.4386 24.1487C16.3244 24.2076 16.236 24.2113 16.1181 24.1524C14.0075 23.0916 11.897 22.0381 9.78272 20.981C9.68695 20.9331 9.61328 20.8963 9.61328 20.76C9.62065 18.9478 9.61696 17.1319 9.61696 15.3197C9.61696 15.2902 9.62065 15.2607 9.62801 15.1981Z"
          fill="#052351"
        />
        <path
          d="M16.2398 9.29376C14.155 10.3361 12.085 11.3712 9.97071 12.4283C12.0813 13.4854 14.1476 14.5168 16.2324 15.5592C16.1809 15.5997 16.144 15.6291 16.1072 15.6512C15.551 15.9864 14.9948 16.3179 14.4386 16.6531C14.3539 16.7047 14.2876 16.7231 14.1882 16.6715C12.1991 15.6697 10.2064 14.6752 8.21374 13.6806C8.17322 13.6585 8.13271 13.6328 8.06641 13.5959C8.71836 13.2018 9.34822 12.8224 10.0075 12.4283C9.3519 11.8979 8.71468 11.3859 8.06641 10.8666C8.12534 10.8334 8.16586 10.8039 8.20637 10.7855C10.1917 9.79101 12.1807 8.80019 14.1661 7.80568C14.2508 7.76148 14.3208 7.73569 14.4128 7.80936C14.9874 8.27715 15.5694 8.73757 16.144 9.20167C16.1735 9.22377 16.1956 9.24956 16.2398 9.29376Z"
          fill="#052351"
        />
        <path
          d="M24.4722 10.8702C23.8276 11.3896 23.1904 11.8979 22.5274 12.4283C23.1794 12.8224 23.8166 13.2055 24.4722 13.5996C24.3949 13.6438 24.347 13.6732 24.2954 13.699C22.3248 14.6825 20.3542 15.6659 18.3873 16.6568C18.2768 16.712 18.1958 16.712 18.0889 16.6457C17.5033 16.2884 16.9176 15.9385 16.2988 15.5665C18.391 14.5204 20.4573 13.4854 22.5753 12.4283C20.461 11.3711 18.391 10.3361 16.3062 9.29372C16.3541 9.24952 16.3799 9.22005 16.413 9.19058C16.9803 8.73385 17.5512 8.28079 18.1184 7.82037C18.1994 7.75407 18.2621 7.74302 18.3615 7.79091C20.3579 8.79278 22.358 9.79097 24.3543 10.7892C24.3912 10.8076 24.4243 10.8334 24.4722 10.8702Z"
          fill="#052351"
        />
        <path
          d="M11.5543 19.0105C11.5727 18.7379 11.79 18.5795 12.0221 18.6422C12.081 18.6569 12.1363 18.6827 12.1915 18.7122C13.035 19.1321 13.8785 19.552 14.7183 19.9755C14.9319 20.0824 15.0277 20.2297 15.0019 20.4028C14.9614 20.6754 14.6925 20.8117 14.4273 20.6827C13.9927 20.4728 13.5617 20.2518 13.1308 20.0382C12.6925 19.8208 12.2578 19.5962 11.8195 19.3825C11.6501 19.2941 11.5506 19.1726 11.5543 19.0105Z"
          fill="#052351"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2692_11640"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
        <clipPath id="clip0_2692_11640">
          <rect width="16.9695" height="17" fill="white" transform="translate(7.51514 7.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PackagingIconMenu
